import { render, staticRenderFns } from "./smsTemplates.vue?vue&type=template&id=d362cc88"
import script from "./smsTemplates.vue?vue&type=script&lang=js"
export * from "./smsTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports